module.exports = __webpack_public_path__ + "img/indietro.c399b2f7.svg";